import { locale as locales } from '@ps/web-poker-dates';
import { formatDistanceStrict } from 'date-fns';

import matchLocale from './matchLocale';

const { log } = console;

export default function getLocalTimeFromServerEST(ts: number, locale: string, base?: Date) {
  const tsMilliseconds = ts * 1000;
  const utsDateTime = new Date(tsMilliseconds);

  const options = { locale: locales.enUS }; // default locale
  let result = '';

  // @ts-ignore TODO: fix types
  if (locale) options.locale = locales[matchLocale(locale)];

  try {
    const compare = base || new Date();

    result = formatDistanceStrict(compare, utsDateTime, options);
  } catch (error) {
    // @ts-ignore TODO: fix types
    log(`Error: ${error.message} converting ${utsDateTime} for relative display`);
  }

  return result;
}
